module.exports = __webpack_public_path__ + "img/key-off_outlined.7363ba76.svg";